import {Switch} from '@wandb/weave/components';
import React, {useState} from 'react';

import {
  useMediaSnapToExistingStepDisplay,
  useShouldShowMediaSnapToExistingStepResetAtLevel,
} from '../../hooks';
import {SettingTitle} from '../common/SettingTitle';
import {useMediaSettingsContext} from '../contexts/MediaSettingsContextProvider';

export const SnapToExistingStep = () => {
  const {updateConfig, unsetConfigField, settingsLevel, panelRef} =
    useMediaSettingsContext();
  const snapToExistingStep = useMediaSnapToExistingStepDisplay(
    settingsLevel,
    panelRef
  );
  const isSetAtLevel = useShouldShowMediaSnapToExistingStepResetAtLevel(
    settingsLevel,
    panelRef
  );
  const [isChecked, setIsChecked] = useState(snapToExistingStep);
  return (
    <div className="flex items-center justify-between">
      <SettingTitle
        title="Snap to step"
        description="Align media display with a specific run for comparison"
        configField="snapToExistingStep"
        isDirty={isSetAtLevel}
        unsetConfigField={() => unsetConfigField('snapToExistingStep')}
      />
      <Switch.Root
        data-test="snap-to-existing-step-checkbox"
        checked={isChecked}
        onCheckedChange={newValue => {
          setIsChecked(newValue);
          updateConfig({snapToExistingStep: newValue});
        }}>
        <Switch.Thumb checked={isChecked} />
      </Switch.Root>
    </div>
  );
};
